<template>
  <DynamicDialog />
</template>

<script setup lang="ts">
  import DynamicDialog from 'primevue/dynamicdialog';
</script>
